var map = {
	"./age_green.svg": [
		94718,
		4718
	],
	"./age_red.svg": [
		13246,
		3246
	],
	"./age_yellow.svg": [
		61861,
		1861
	],
	"./duration_green.svg": [
		2317,
		2317
	],
	"./duration_orange.svg": [
		35594,
		5594
	],
	"./duration_red.svg": [
		69569,
		9569
	],
	"./duration_yellow.svg": [
		50772,
		772
	],
	"./logo.svg": [
		58664
	],
	"./ltv_green.svg": [
		68037,
		8037
	],
	"./ltv_orange.svg": [
		90242,
		7861
	],
	"./ltv_red.svg": [
		92105,
		2105
	],
	"./ltv_yellow.svg": [
		65676,
		5676
	],
	"./nhg_no.svg": [
		36692,
		6692
	],
	"./nhg_unknown.svg": [
		79365,
		9365
	],
	"./nhg_yes.svg": [
		86078,
		6078
	],
	"./pension_green.svg": [
		11969,
		1969
	],
	"./pension_orange.svg": [
		69078,
		6697
	],
	"./pension_red.svg": [
		11093,
		1093
	],
	"./pension_yellow.svg": [
		19976,
		9976
	],
	"./result_negative.svg": [
		6796
	],
	"./result_positive.svg": [
		80516
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(() => {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 43332;
module.exports = webpackAsyncContext;